import { globals } from '../../globals'
import { UPDATE_DATA } from './updateData'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_FAVORITE_START = 'CREATE_FAVORITE_START'
export const NEW_FAVORITE_CREATED = 'NEW_FAVORITE_CREATED'
export const NEW_FAVORITE_FAILED = 'NEW_SUBJECT_FAILED'
export const NONUNIQUE_FAVORITE_NAME = 'NONUNIQUE_FAVORITE_NAME'
export const DELETE_FAVORITE_START = 'DELETE_FAVORITE_START'
export const FAVORITE_DELETED = 'FAVORITE_DELETED'
export const DELETE_FAVORITE_FAILED = 'DELETE_FAVORITE_FAILED'
export const EDIT_FAVORITE_START = 'EDIT_FAVORITE_START'
export const FAVORITE_EDITED = 'FAVORITE_EDITED'
export const EDIT_FAVORITE_FAILED = 'EDIT_FAVORITE_FAILED'
export const GET_FAVORITE_START = 'GET_FAVORITE_START'
export const FAVORITE_FETCHED = 'FAVORITE_FETCHED'
export const GET_FAVORITE_FAILED = 'GET_FAVORITE_FAILED'
export const DATA_FETCHED = 'DATA_FETCHED'
export const ADD_ITEM_TO_FAVORITE_START = 'ADD_ITEM_TO_FAVORITE_START'
export const ADD_ITEM_TO_FAVORITE_CREATED = 'ADD_ITEM_TO_FAVORITE_CREATED'
export const ADD_ITEM_TO_FAVORITE_FAILED = 'ADD_ITEM_TO_FAVORITE_FAILED'
export const REMOVE_ITEM_FROM_FAVORITE_SUCCESS = 'REMOVE_ITEM_FROM_FAVORITE_SUCCESS'
export const GET_ITEM_FROM_FAVORITE_START = 'GET_ITEM_FROM_FAVORITE_START'
export const GET_ITEM_FROM_FAVORITE_SUCCESS = 'GET_ITEM_FROM_FAVORITE_SUCCESS'
export const GET_ITEM_FROM_FAVORITE_FAILED = 'GET_ITEM_FROM_FAVORITE_FAILED'
// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  getFavoritesList
}

const headers = {
  'Content-Type': 'application/json'
}

export function createFavoritesList (favorite) {
  return (dispatch) => {
    dispatch({ type: CREATE_FAVORITE_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(favorite)
    }
    fetch(`${globals.apiUrl}/api/personallist`, options).then((response) => {
      if (response.status === 400) {
        return dispatch({ type:  NONUNIQUE_FAVORITE_NAME })
      } else if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: NEW_FAVORITE_CREATED,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: NEW_FAVORITE_FAILED })
    })
  }
}

export function editFavoritesList (favorite) {
  return (dispatch) => {
    dispatch({ type: EDIT_FAVORITE_START })
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(favorite),
    }
    fetch(`${globals.apiUrl}/api/personallist`, options).then((response) => {
      if (response.status === 400) {
        dispatch({ type:  NONUNIQUE_FAVORITE_NAME })
      } else if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: FAVORITE_EDITED,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: EDIT_FAVORITE_FAILED })
    })
  }
}

export function getFavoritesList (usage) {
  return (dispatch) => {
    dispatch({ type: GET_FAVORITE_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/personallist?usage=${usage}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 404) {
        dispatch({
          type: FAVORITE_FETCHED,
          payload: {
            json: []
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: FAVORITE_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_FAVORITE_FAILED })
    })
  }
}

export function deleteFavoritesList (listId) {
  return (dispatch) => {
    dispatch({ type: DELETE_FAVORITE_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/personallist/${listId}`, options).then((response) => {
      if (response.status === 200) {
        dispatch({ type: FAVORITE_DELETED })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_FAVORITE_FAILED })
    })
  }
}

export function addItemToFavorites (favoriteItem) {
  return (dispatch) => {
    dispatch({ type: ADD_ITEM_TO_FAVORITE_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(favoriteItem)
    }
    fetch(`${globals.apiUrl}/api/personallistitem`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: ADD_ITEM_TO_FAVORITE_CREATED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: ADD_ITEM_TO_FAVORITE_FAILED })
    })
  }
}

export function removeItemFromFavorites (favoriteItem) {
  let params = ''
  if (favoriteItem.PersonalListId.length > 1) {
    favoriteItem.PersonalListId.map(item => {
      params = `${params}listid=${item}&`
    })
    params = `${params}itemid=${favoriteItem.ItemId}`
  } else {
    params = `listid=${favoriteItem.PersonalListId}&itemid=${favoriteItem.ItemId}`
  }
  return (dispatch) => {
    dispatch({ type: ADD_ITEM_TO_FAVORITE_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/personallistitem?${params}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: REMOVE_ITEM_FROM_FAVORITE_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: ADD_ITEM_TO_FAVORITE_FAILED })
    })
  }
}

export function getItemFavorite (itemId, usage) {
  return (dispatch) => {
    dispatch({ type: GET_ITEM_FROM_FAVORITE_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/personallistitem?itemId=${itemId}&usage=${usage}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_ITEM_FROM_FAVORITE_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_ITEM_FROM_FAVORITE_FAILED })
    })
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => {
    const { page, field } = action.location
    const { value } = action.payload
    if (page !== 'Bill') {
      return state
    }
    switch (action.valueType) {
      case 'ch': {
        // mark single checkbox as checked
        const resultedSelectedArray = Array.isArray(value)
          ? [...state.formDataValue[page][field].selected, ...value]
          : [...state.formDataValue[page][field].selected, value]
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [page]: {
              ...state.formDataValue[page],
              [field]: {
                ...state.formDataValue[page][field],
                selected: resultedSelectedArray
              }
            }
          }
        }
      }
      case 'ch_uncheck': {
        // uncheck single checkbox
        const { page, field } = action.location
        const { value } = action.payload
        let resultedSelectedArray = state.formDataValue[page][field].selected
        if (Array.isArray(value)) {
          value.forEach(item => {
            resultedSelectedArray = resultedSelectedArray.filter(function (element) {
              return element !== item
            })
          })
        } else {
          const idIndex = state.formDataValue[page][field].selected.indexOf(value)
          resultedSelectedArray = [
            ...resultedSelectedArray.slice(0, idIndex),
            ...resultedSelectedArray.slice(idIndex + 1)
          ]
        }
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [page]: {
              ...state.formDataValue[page],
              [field]: {
                ...state.formDataValue[page][field],
                selected: resultedSelectedArray
              }
            }
          }
        }
      }
    }
  },
  [DATA_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        groupNotes: {
          favoritesList: json.FavoritesList,
          clientId: json.ClientId,
          userId: json.UserId
        }
      }
    }
  },
  [CREATE_FAVORITE_START] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        favoritesFetching: true
      }
    }
  },
  [NEW_FAVORITE_CREATED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        favoriteId: json,
        favoritesFetching: false,
        uniqueFavoriteName: true
      }
    }
  },
  [NEW_FAVORITE_FAILED] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        favoritesFetching: false,
        uniqueFavoriteName: false
      }
    }
  },
  [NONUNIQUE_FAVORITE_NAME] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        favoritesFetching: false,
        uniqueFavoriteName: false
      }
    }
  },
  [FAVORITE_EDITED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        editedFavoriteResult: json
      }
    }
  },
  [FAVORITE_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        fetchedFavorite: json
      }
    }
  },
  [ADD_ITEM_TO_FAVORITE_CREATED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        addedToPersList: json
      }
    }
  },
  [REMOVE_ITEM_FROM_FAVORITE_SUCCESS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        removedFromPersList: json
      }
    }
  },
  [GET_ITEM_FROM_FAVORITE_SUCCESS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        receivedPersonalIds: json
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {},
  formDataValue: {
    Bill: {
      favorites: {
        selected: []
      }
    },
    R: {
      favorites: {
        selected: [],
      },
      groupNotesOptions: {
        selected: []
      }
    },
    L: {
      favorites: {
        selected: []
      },
      groupNotesOptions: {
        selected: []
      }
    }
  }
}
export default function favoritesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/favorites.js